import { StaffService } from "@/api/staff-members";
import { buildFormData } from "@/utils/form-data-builder";
import { DEFAULT_PER_PAGE } from "@/constants/ui-components";
import type {
  CreateStaffMemberRequestData,
  StaffMember,
  StaffMembersParams,
  StaffMembersResponse,
  UpdateStaffMemberRequestData,
} from "@/api/staff-members/types";

export class StaffMembersRepository {
  private static _instance: StaffMembersRepository;

  static get instance(): StaffMembersRepository {
    if (!this._instance) {
      this._instance = new StaffMembersRepository();
    }
    return this._instance;
  }

  private constructor() {}

  async getStaffMembers(
    params: StaffMembersParams = {},
  ): Promise<StaffMembersResponse> {
    const response = await StaffService.instance.getStaffMembers(params);

    return {
      data: response.data.staffMembers,
      meta: {
        currentPage: parseInt(
          response.headers["x-current-page"] || String(params.page || 1),
          10,
        ),
        perPage: parseInt(
          response.headers["x-per-page"] || String(DEFAULT_PER_PAGE),
          10,
        ),
        total: parseInt(response.headers["x-total-count"] || "0", 10),
        totalPages: parseInt(response.headers["x-total-pages"] || "1", 10),
      },
    };
  }

  async createStaffMember(
    data: CreateStaffMemberRequestData,
  ): Promise<StaffMember> {
    const { avatar, ...userProfile } = data.staffMember.userProfile;

    const payload = {
      staffMember: {
        ...data.staffMember,
        userProfile,
      },
    };

    if (avatar !== undefined && avatar !== null && avatar !== "") {
      const formData = buildFormData(payload, {
        fileField: {
          key: "staffMember[userProfile][avatar]",
          value: avatar,
        },
      });
      return StaffService.instance.createStaffMemberFormData(formData);
    }

    return StaffService.instance.createStaffMember(payload);
  }

  async updateStaffMember(
    id: number,
    data: UpdateStaffMemberRequestData,
  ): Promise<StaffMember> {
    const { avatar, ...userProfileData } = data.staffMember.userProfile;

    const payload = {
      staffMember: {
        userProfile: userProfileData,
        status: data.staffMember.status,
        disciplineIds: data.staffMember.disciplineIds,
      },
    };

    if (avatar !== undefined && avatar !== null) {
      const formData = buildFormData(payload, {
        fileField: {
          key: "staffMember[userProfile][avatar]",
          value: avatar,
        },
      });
      return StaffService.instance.updateStaffMemberFormData(id, formData);
    }

    return StaffService.instance.updateStaffMember(id, payload);
  }
}
